import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withAnalytics from '../../hocs/withAnalytics';
import { useGetSeoLinkUrl } from './hooks';
import styles from './SeoLink.module.css';

const SeoLink = ({
  children,
  className,
  url,
  productType,
  linkConfig,
  stopPropagation,
}) => {
  const linkUrl = useGetSeoLinkUrl({ linkConfig, url, productType });
  const linkProps = { ...(linkUrl ? { href: linkUrl } : {}) };

  const onClick = useCallback(
    (event) => {
      event.preventDefault();
      stopPropagation && event.stopPropagation();
    },
    [stopPropagation]
  );

  return linkUrl ? (
    <a
      {...linkProps}
      onClick={onClick}
      className={classNames(styles.component, className)}
    >
      {children}
    </a>
  ) : (
    children
  );
};

SeoLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  url: PropTypes.string,
  productType: PropTypes.string,
  linkConfig: PropTypes.shape({
    type: PropTypes.string,
    uriPath: PropTypes.string,
    productType: PropTypes.string,
  }),
  stopPropagation: PropTypes.bool,
};

export default SeoLink;

export const SeoLinkWithAnalytics = withAnalytics(SeoLink);
